import { setCAttrConfig, setCAttrFilters } from "../slices/clone.slice";
import {
  setAttrConfig,
  setAttrFilters,
  setAttrLoading,
} from "../slices/EIPMapValueDefinition.slice";
import { baseApi } from "./baseApi";

export const attributesApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAttrConfig: builder.query({
      query: () => "/configs/627214d0a267cd4ef44f9d40",
      async onQueryStarted(moduleName, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          if (moduleName === "clone") {
            dispatch(setCAttrConfig(data));
          } else {
            dispatch(setAttrConfig(data));
          }
          const root = data.attributes.configs.filter((attr) => attr.root);

          if (!root[0].values) {
            // get root values
            dispatch(
              attributesApi.endpoints.getAttributes.initiate({
                configId: data._id,
                attrName: root[0].name,
                filters: {},
                moduleName,
              })
            );
          }
        } catch (e) {
          console.log("execption", e);
        }
      },
    }),
    getAttributes: builder.query({
      query: ({ configId, attrName, filters }) => {
        const filterString = Object.keys(filters)
          .map((key) => key + ":" + filters[key])
          .join(",");
        return `/attributes?configID=${configId}&getAttributes=${attrName}&filters=${filterString}`;
      },
      async onQueryStarted(
        { moduleName },
        { dispatch, getState, queryFulfilled }
      ) {
        try {
          const { data } = await queryFulfilled;
          const state = getState();

          // Add "ALL" for Map Value Definition searches, but not clone targets.
          const standardCodeSystem = data.attributes?.find(
            (attr) => attr.name === "Standard_Code_System"
          );
          const standardCodeValues = standardCodeSystem?.values || [];
          const standardCodeValuesWithAll =
            moduleName === "clone"
              ? standardCodeValues.filter((value) => value !== "ALL")
              : standardCodeValues.includes("ALL")
              ? standardCodeValues
              : ["ALL", ...standardCodeValues];

          const newConfigs =
            moduleName === "clone"
              ? { ...state.clone.cAttrConfig }
              : { ...(state.map?.attrConfig || {}) };
          const configs = newConfigs.attributes.configs;
          const transformedAttrConfig = [...configs];

          const transformedAttrFilters = configs.map((obj, index) => {
            const attributeData = data.attributes.find(
              (targetElement) => obj.name === targetElement.name
            );
            const isStandardCodeSystem =
              obj.name === "Standard_Code_System" &&
              standardCodeSystem?.name === "Standard_Code_System";
            const values = isStandardCodeSystem
              ? standardCodeValuesWithAll
              : attributeData?.values || obj?.values;

            transformedAttrConfig[index] = {
              ...transformedAttrConfig[index],
              values,
            };

            return {
              ...obj,
              _id: index,
              disabled: !values,
              values: !values
                ? []
                : values.map((item, index) => ({
                    id: index,
                    label: item,
                    value: item,
                  })),
            };
          });
          if (moduleName === "clone") {
            dispatch(
              setCAttrConfig({
                ...newConfigs,
                attributes: {
                  ...newConfigs.attributes,
                  configs: transformedAttrConfig,
                },
              })
            );
            dispatch(setCAttrFilters(transformedAttrFilters));
          } else {
            dispatch(
              setAttrConfig({
                ...newConfigs,
                attributes: {
                  ...newConfigs.attributes,
                  configs: transformedAttrConfig,
                },
              })
            );
            dispatch(setAttrFilters(transformedAttrFilters));
            dispatch(setAttrLoading(false));
          }
        } catch (e) {
          console.log("execption", e);
        }
      },
    }),
  }),
});

export const {
  useGetAttrConfigQuery,
  useGetAttributesQuery,
  useLazyGetAttributesQuery,
} = attributesApi;
